<div class="Calendar">
  <div class="Calendar__DayOfWeek">
    @for (day of daysOfTheWeek; track day) {
      <div
        class="Calendar__WeekName"
        [ngClass]="{ Calendar__Mobile: isMobileView }"
      >
        <!-- day of the week -->
        {{ day }}
      </div>
    }
  </div>
  <div class="Calendar__Days">
    @for (singleDay of displayDays; track singleDay) {
      <div>
        @if (!isMobileView) {
          <lib-calendar-day-cell
            (statusPillClicked)="statusPillCliked.emit($event)"
            [statusses]="config.statusses"
            [singleDay]="singleDay"
          >
          </lib-calendar-day-cell>
        } @else {
          <lib-calendar-mobile-day-cell
            [statusses]="config.statusses"
            [singleDay]="singleDay"
            (click)="mobileDayClicked.emit(singleDay.data)"
          >
          </lib-calendar-mobile-day-cell>
        }
      </div>
    }
  </div>
</div>
